import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showDependentCreateModal } from '../../../redux/ui/popup';
import { usePageView } from '../../../hocs/usePageView';
import { redirectToUsers } from '../../../utils/appointments/redirect-utils';
import { CustomEvents, GATrackCustomEvent } from '../../../gtag';
import { loggedUserIdSelector } from '../../../redux/context/selectors';
import { selectDependentFormSubmitRedirect } from '../../../redux/dependentForm/selectors';
import { DEPENDENT_FORM_SUBMIT_REDIRECT } from '../../../constants';
import { myProfileRedirectActions } from '../../../redux/profiles/my-profile-redirect';

const DependentComplete = () => {
  const dispatch = useDispatch();

  usePageView('Add Dependent | Complete');

  const id = useSelector(loggedUserIdSelector);
  const submitRedirect = useSelector(selectDependentFormSubmitRedirect);

  useEffect(() => {
    const options = { onClose: redirectToGetCare };
    dispatch(showDependentCreateModal(options));
  }, []);

  const redirectToGetCare = () => {
    if (submitRedirect === DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE) {
      redirectToUsers(id, false);
      GATrackCustomEvent(CustomEvents.GET_CARE_START);
    } else if (submitRedirect === DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE) {
      dispatch(myProfileRedirectActions.goToProfile());
    }
  };

  return null;
};

export default DependentComplete;



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentComplete/index.jsx